import { Boton } from '../componentes/Boton';
import { Tarjeta } from '../componentes/EstadoPagina';

/**
 * «Sin permiso» del backoffice (1.21, captura `sin-permiso-soporte`): el candado en baldosa negra, «Tu rol no puede ver
 * <sección>», «Entras como Soporte de plataforma. Pídeselo a un Superadmin.» y «Ir a Negocios».
 */
export function SinPermiso({ seccion, superadmin, movil, onIr }: { seccion: string; superadmin: boolean; movil: boolean; onIr: (() => void) | null }) {
    return (
        <Tarjeta
            icono="lock"
            baldosa="var(--rv-ink)"
            tinta="#fff"
            ceja="Sin permiso"
            cejaColor="var(--rv-fg-3)"
            titulo={`Tu rol no puede ver ${seccion}`}
            texto={`Entras como ${superadmin ? 'Superadmin' : 'Soporte'} de plataforma. Pídeselo a un Superadmin.`}
            botones={
                onIr === null ? undefined : (
                    <Boton tipo="secundario" icono="building-2" movil={movil} onClick={onIr}>
                        Ir a Negocios
                    </Boton>
                )
            }
        />
    );
}
